module.exports = __webpack_public_path__ + "img/monetizze-white.bf305dd2.svg";